// ScrollUnlocker.tsx
import { useEffect } from "react";

export default function ScrollUnlocker() {
  useEffect(() => {
    const unlock = () => {
      const html = document.documentElement;
      const body = document.body;

      // Xóa các class thường dùng để khóa scroll (Bootstrap/Antd/tuỳ dự án)
      body.classList.remove("modal-open", "drawer-open", "overflow-hidden", "no-scroll");
      html.classList.remove("overflow-hidden", "no-scroll");

      // Mở lại overflow
      html.style.overflowY = "auto";
      body.style.overflowY = "auto";
      body.style.position = "";
      html.style.position = "";

      // iOS đôi khi cần force reflow để “nhả” scroll
      void body.offsetHeight;
    };

    // chạy ngay và sau 1 nhịp event loop
    unlock();
    const t = setTimeout(unlock, 100);

    // Nếu có thứ gì đó lại khoá, thì auto gỡ
    const mo = new MutationObserver(unlock);
    mo.observe(document.body, { attributes: true, attributeFilter: ["class", "style"] });
    return () => { clearTimeout(t); mo.disconnect(); };
  }, []);

  return null;
}
